import { AccountView } from '../../react/accounts/AccountView';
import { ArticleTypeView } from '../../react/articletypes/ArticleTypeView';
import { AssortmentPlanning } from '../../react/purchasing/assortmentPlanning';
import { BrandView } from '../../react/brands/BrandView';
import { BudgetImport } from '../../react/product/import/BudgetImport';
import { BusinessAreaView } from '../../react/businessareas/BusinessAreaView';
import { ColourChange } from '../../react/product/colourChange';
import { CompanyView } from '../../react/companies/CompanyView';
import { CountryView } from '../../react/countries/CountryView';
import { CurrencyView } from '../../react/currencies/CurrencyView';
import { CustomerGroupView } from '../../react/customergroups/CustomerGroupView';
import { DeliveryPlanningTemplateView } from '../../react/deliveryplanningtemplates/DeliveryPlanningTemplateView';
import { DeliveryTermView } from '../../react/deliveryterms/DeliveryTermView';
import { DepartmentView } from '../../react/departments/DepartmentView';
import { ExternalImportFileList } from '../../react/product/import/ExternalImportFileList.tsx';
import { FooBar } from '../../react/FooBar';
import { IntrastatView } from '../../react/intrastats/IntrastatView';
import { InvoiceTypeView } from '../../react/invoicetypes/InvoiceTypeView';
import { LocationView } from '../../react/locations/LocationView';
import { MetaFieldValues } from '../../react/MetaFieldValues';
import { MetaFields } from '../../react/MetaFields';
import { OrderTypeView } from '../../react/ordertypes/OrderTypeView';
import { PaymentTermView } from '../../react/paymentterms/PaymentTermView';
import { PaymentTypeView } from '../../react/paymenttypes/PaymentTypeView';
import { PsychologicalPriceView } from '../../react/psychologicalprices/PsychologicalPriceView';
import { ReturnReasonView } from '../../react/returnreasons/ReturnReasonView';
import { SalesComparisonView } from '../../react/sales/SalesComparisonView';
import { ShippingMethodView } from '../../react/shippingmethods/ShippingMethodView';
import { SubCategoryView } from '../../react/subcategories/SubCategoryView';
import { UserView } from '../../react/users/UserView';
import { VatView } from '../../react/vats/VatView';
import { VolumeDiscountView } from '../../react/volumediscounts/VolumeDiscountView';
import { bridgeConverter } from '../../bridge/bridgeConverter.tsx';

angular
    .module('app.bridgeComponents', [])
    .component('fooBar', bridgeConverter(FooBar, ['hello']))
    .component('metaFieldValues', bridgeConverter(MetaFieldValues, ['values', 'initialIsEditing']))
    .component('metaFields', bridgeConverter(MetaFields, ['fields', 'initialIsEditing']))
    .component('colourChange', bridgeConverter(ColourChange, ['articleId']))
    .component('externalImportFileList', bridgeConverter(ExternalImportFileList, []))
    .component('assortmentPlanning', bridgeConverter(AssortmentPlanning, ['hi']))
    .component('salesComparisonView', bridgeConverter(SalesComparisonView, []))
    .component('brandView', bridgeConverter(BrandView, ['brandId', 'currentUser']))
    .component('budgetImport', bridgeConverter(BudgetImport, []))
    .component('companyView', bridgeConverter(CompanyView, ['companyId']))
    .component('userView', bridgeConverter(UserView, ['userId']))
    .component('accountView', bridgeConverter(AccountView, ['accountId']))
    .component('currencyView', bridgeConverter(CurrencyView, ['currencyId']))
    .component('customerGroupView', bridgeConverter(CustomerGroupView, ['customerGroupId']))
    .component('articleTypeView', bridgeConverter(ArticleTypeView, ['articleTypeId']))
    .component('paymentTypeView', bridgeConverter(PaymentTypeView, ['paymentTypeId']))
    .component('returnReasonView', bridgeConverter(ReturnReasonView, ['returnReasonId']))
    .component('shippingMethodView', bridgeConverter(ShippingMethodView, ['shippingMethodId']))
    .component('paymentTermView', bridgeConverter(PaymentTermView, ['paymentTermId']))
    .component('deliveryTermView', bridgeConverter(DeliveryTermView, ['deliveryTermId']))
    .component('countryView', bridgeConverter(CountryView, ['countryId']))
    .component('departmentView', bridgeConverter(DepartmentView, ['departmentId']))
    .component('subCategoryView', bridgeConverter(SubCategoryView, ['subCategoryId']))
    .component('invoiceTypeView', bridgeConverter(InvoiceTypeView, ['invoiceTypeId']))
    .component('vatView', bridgeConverter(VatView, ['vatId']))
    .component('deliveryPlanningTemplateView', bridgeConverter(DeliveryPlanningTemplateView, ['deliveryPlanningTemplateId']))
    .component('orderTypeView', bridgeConverter(OrderTypeView, ['orderTypeId']))
    .component('locationView', bridgeConverter(LocationView, ['locationId', 'allowUpdate', 'isAllowedToSetAutoOrder']))
    .component('intrastatView', bridgeConverter(IntrastatView, ['intrastatId']))
    .component('businessAreaView', bridgeConverter(BusinessAreaView, ['businessAreaId']))
    .component('volumeDiscountView', bridgeConverter(VolumeDiscountView, ['volumeDiscountId']))
    .component('psychologicalPriceView', bridgeConverter(PsychologicalPriceView, ['psychologicalPriceId']));
